import { __assign, __awaiter, __generator } from "tslib";
import CommandsExecutor from '../commands-executor/commands-executor';
import { Topology, AddToCartActionOption } from '../constants';
var CartActions = /** @class */ (function () {
    function CartActions(siteStore, pubSubManager, origin, sectionId) {
        this.siteStore = siteStore;
        this.pubSubManager = pubSubManager;
        this.origin = origin;
        this.sectionId = sectionId;
        this.cartWidgetEventSum = 0;
        this.commandsExecutor = new CommandsExecutor(Topology.CART_COMMANDS_URL, this.siteStore.httpClient);
        this.trackCartPopupExists();
    }
    CartActions.prototype.addToCart = function (productId, optionsSelections, quantity, customTextFields, addToCartAction) {
        if (customTextFields === void 0) { customTextFields = []; }
        if (addToCartAction === void 0) { addToCartAction = AddToCartActionOption.MINI_CART; }
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendCommandAddToCart(productId, optionsSelections, quantity, customTextFields)];
                    case 1:
                        cartSummary = (_a.sent()).cartSummary;
                        this.onAddToCartCompleted(cartSummary, addToCartAction);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartActions.prototype.addItemsToCart = function (addToCartItems, addToCartAction) {
        if (addToCartAction === void 0) { addToCartAction = AddToCartActionOption.MINI_CART; }
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.AddCartItemsCommand(addToCartItems)];
                    case 1:
                        cartSummary = (_a.sent()).cartSummary;
                        this.onAddToCartCompleted(cartSummary, addToCartAction);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartActions.prototype.shouldNavigateToCart = function () {
        return !this.isMiniCartExists();
    };
    CartActions.prototype.onAddToCartCompleted = function (cartSummary, addToCartAction) {
        if (addToCartAction === void 0) { addToCartAction = AddToCartActionOption.MINI_CART; }
        this.saveCart(cartSummary, addToCartAction === AddToCartActionOption.MINI_CART);
        if (addToCartAction === AddToCartActionOption.CART ||
            (addToCartAction !== AddToCartActionOption.NONE && this.shouldNavigateToCart())) {
            this.navigateToCart(this.origin);
        }
    };
    CartActions.prototype.trackCartPopupExists = function () {
        var _this = this;
        var eventId = this.pubSubManager.subscribe('Minicart.isExist', function (isExists) {
            if (isExists === true || (isExists && isExists.data === true)) {
                _this.cartWidgetEventSum++;
            }
            else {
                _this.cartWidgetEventSum--;
            }
            if (_this.siteStore.isSiteMode()) {
                _this.pubSubManager.unsubscribe('Minicart.isExist', eventId);
            }
        }, true);
    };
    CartActions.prototype.isMiniCartExists = function () {
        return this.cartWidgetEventSum > 0;
    };
    CartActions.prototype.sendCommandAddToCart = function (productId, optionsSelections, quantity, customTextFields) {
        if (customTextFields === void 0) { customTextFields = []; }
        return __awaiter(this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = {
                            productId: productId,
                            quantity: quantity,
                        };
                        if (Array.isArray(optionsSelections)) {
                            postData.optionsSelections = optionsSelections;
                        }
                        else {
                            postData.optionsSelectionsByNames = optionsSelections;
                        }
                        postData.freeText = customTextFields.map(function (customTextFieldAnswer) {
                            return {
                                title: customTextFieldAnswer.customText.title,
                                value: customTextFieldAnswer.answer,
                            };
                        });
                        return [4 /*yield*/, this.commandsExecutor.execute('AddCartItemCommand', postData)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    CartActions.prototype.AddCartItemsCommand = function (addToCartItems) {
        return __awaiter(this, void 0, void 0, function () {
            var postData, products;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = {
                            products: null,
                        };
                        products = addToCartItems.map(function (item) {
                            var options = __assign({ choices: {}, customTextFields: [] }, item.options);
                            var data = {
                                productId: item.productID,
                                quantity: item.quantity,
                                freeText: options.customTextFields,
                            };
                            if (Array.isArray(options.choices)) {
                                data.optionsSelections = options.choices;
                            }
                            else {
                                data.optionsSelectionsByNames = options.choices;
                            }
                            return data;
                        });
                        postData.products = products;
                        return [4 /*yield*/, this.commandsExecutor.execute('AddCartItemsCommand', postData)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    CartActions.prototype.saveCart = function (cartSummary, shouldOpenMiniCart) {
        if (shouldOpenMiniCart === void 0) { shouldOpenMiniCart = true; }
        cartSummary.extraParams = { origin: this.origin };
        cartSummary.eventOptions = { shouldOpenCart: shouldOpenMiniCart };
        this.pubSubManager.publish('Cart.Changed', cartSummary);
    };
    CartActions.prototype.navigateToCart = function (origin) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.siteStore.navigate({
                        sectionId: this.sectionId,
                        queryParams: { origin: origin },
                    }, true)];
            });
        });
    };
    return CartActions;
}());
export { CartActions };
//# sourceMappingURL=cartActions.js.map